module.exports = __webpack_public_path__ + "static/kuo_toa-25c999132e1205da7d82094d0a054339.jpg";